import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=c4c86e00&scoped=true&"
import script from "./permissions.vue?vue&type=script&lang=js&"
export * from "./permissions.vue?vue&type=script&lang=js&"
import style0 from "./permissions.vue?vue&type=style&index=0&id=c4c86e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c86e00",
  null
  
)

export default component.exports